@if (dataSource?.data?.length) {

  <div class="w-full border border-gray-200 rounded-md overflow-hidden">

    <div class="flex flex-row items-center w-full border-b border-gray-200 bg-gray-50 sticky top-0 z-10">
      <div class="shrink-0 w-[50%] p-4 font-semibold text-xs text-gray-500">NAME</div>
      <div class="shrink-0 w-[50%] p-4 font-semibold text-xs text-gray-500">BERECHTIGUNG</div>
    </div>

    @for (element of dataSource.data; track element.id) {
      <div class="flex flex-row items-center w-full border-b border-gray-200 hover:bg-gray-100 transition-colors last:border-b-0">
        <div class="shrink-0 w-[50%] p-4 break-words font-medium text-sm">{{ element.name }}</div>
        <div class="shrink-0 w-[50%] p-4 break-words font-medium text-sm">{{ user.roleInOrganisations[element.id].name | roleAndPrivileges }}</div>
      </div>
    }
  </div>
  }

@else {
 <div class="border border-dashed border-gray-200 rounded-md p-6 text-center text-sm text-gray-500">
 Noch keiner Organisation hinzugefügt </div>
}
  @if (leaveOrganisationBoolean) {
    <app-pop-up [header]="'Unternehmen verlassen?'" [message]="'Durch diesen Vorgang verlassen Sie das Unternehmen ' + selectedOrganisation.name + '.' +
 '<br> <br> Sie verlieren somit den Zugang zu allen Projekten ihres Unternehmens!'" [approveButtonName]="'Bestätigen'" (approvedPressed)="leaveOrganisation(selectedOrganisation)" (declinedPressed)="leaveOrganisationBoolean=false"></app-pop-up>
  }

  @if (deleteOrganisationBoolean) {
    <app-pop-up [header]="'Unternehmen löschen?'" [holdable]="true" [message]="'Durch diesen Vorgang wird das Unternehmen ' + selectedOrganisation.name +
 ' unwiderruflich gelöscht! <br> <br> Alle Personen werden aus dem Unternehmen entfernt und dieses anschließend gelöscht!'" [approveButtonName]="'Bestätigen'" (approvedPressed)="deleteOrganisation(selectedOrganisation)" (declinedPressed)="deleteOrganisationBoolean = false"></app-pop-up>
  }

  @if (deleteAndLeaveOrganisationBoolean) {
    <app-pop-up [header]="'Unternehmen lösche und verlassen?'" [holdable]="true" [message]="'Durch diesen Vorgang wird das Unternehmen ' + selectedOrganisation.name +
 ' unwiderruflich gelöscht. <br> <br> Da Sie die administrative Rolle des Unternehmens besitzen, wird dieses beim Verlassen gelöscht! <br> Fall Sie lediglich das Unternehmen verlassen wollen, ernennen Sie zuvor einen zusätzlichen Administrator, der Ihre Position übernimmt! '" [approveButtonName]="'Bestätigen'" (approvedPressed)="deleteOrganisation(selectedOrganisation)" (declinedPressed)="deleteAndLeaveOrganisationBoolean = false"></app-pop-up>
  }


